import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";

addToChainBefore(chain, ExecuteOnSuccessCallback, async props => {
    const resultCategories = await getProductCategories({
        productIds:
            props.apiParameter.cart.cartLines
                ?.filter(line => line.productId !== null && line.productId !== undefined)
                .map(line => line.productId!) || [], // Ensure productIds is always an array
        type: "product",
    });

    if (resultCategories.successful) {
        const carrier = props.apiParameter.cart.carrier;
        const cart = props.apiParameter.cart;
        const billTo = props.apiResult.billTo;
        const shipTo = props.apiResult.shipTo;
        const orderNumber = props.apiResult.cart.orderNumber;
        const productCategories = resultCategories.result;

        // Add null check for props.apiResult.cartLines
        if (props.apiParameter.cart.cartLines) {
            setGA4Event(props.apiParameter.cart.cartLines, "purchase", {
                productCategories,
                carrier,
                cart,
                billTo,
                shipTo,
                orderNumber,
            });
        }
    }
});
